import styled from 'styled-components/native';

import LogoImage from 'assets/logo.png';

export default styled.Image.attrs({ source: LogoImage, resizeMode: 'contain' })`
  width: 50px;
  height: 43px;
  margin-bottom: 25px;
`;
